<template>
  <main class="blog" :class="{ 'blog--reading': this.post }">
    <blog-nav :content="content" :filters="filters" :navs="navs" :search="search" v-on:clearFeed="clearFeed" />
    <blog-feed :filters="filters" :feed="feed" :website="website"/>
    <blog-post :postLoadState="loadPostReady" :post="slug" :feed="singlepost" v-on:getPost="getPost" v-on:setPostLoadState="setPostLoadState"/>
    <div class="clearfix">&nbsp;</div>
    <blog-footer v-if="(!post) && feed.length > 0"  v-inview:enter="loadFeed" :filters="filters" :destinationpoints="destinationpoints"/>
  </main>
</template>

<script>
import BlogNav from './BlogNav'
import BlogFeed from './BlogFeed'
import BlogPost from './BlogPost'
import BlogFooter from './BlogFooter'
import { axios } from '../helpers'
export default {
  name: 'blog',
  components: { BlogNav, BlogFeed, BlogPost, BlogFooter },
  resource: 'Blog',
  props: {
    post: String,
    author: String,
    search: String,
    slug: String,
    category: String
  },
  methods: {
    loadFeed(ele, total = 6) {
      console.log(this.lastestResult);
      if (this.lastestResult >= 6) {
        var slug = this.slug || '';
        var category = this.category || '';
        var url = `http://haidangtravel.com/api/blog` + (slug !== '' ? '/' + slug : '');
        if (this.$route.name === 'category') {
          url = `http://haidangtravel.com/api/blog/category/` + category;
        }
        if (this.feed.length === 1 && slug === '') {
          this.clearFeed();
        }
        if (!(ele !== null && slug !== '')) {
          axios.post(url, {
            begin: this.feed.length,
            take: total,
            slug: slug,
            category: category,
            search: this.search
          }).then(response => {
            this.feed = this.feed.concat(response.data);
            this.lastestResult = response.data.length;
            if (slug !== '') {
              this.singlepost = response.data[0];
            }
          });
        }
      }
    },
    getPost: function(slug) {
      this.loadPostReady = false;
      var url = `http://haidangtravel.com/api/blog/` + slug;
      axios.post(url, {
        begin: this.feed.length,
        take: 1,
        slug: slug
      }).then(response => {
        this.singlepost = response.data[0] || {};
        this.loadPostReady = true;
      });
    },
    clearFeed() {
      if (this.$route.name !== 'slug') {
        this.feed = [];
      }
    },
    setBegin(val) {
      this.begin = val;
    },
    setPostLoadState(value) {
      this.postLoadState = value;
    },
    getDestinationpoints: function() {
      let url = `http://haidangtravel.com/api/destinationpoint`;
      axios.post(url).then(response => {
        this.destinationpoints = response.data;
      });
    }
  },
  data() {
    return {
      navs: 0,
      title: '',
      labels: {
        post: '',
        author: '',
        search: '',
        category: ''
      },
      feed: [],
      begin: 0,
      website: '',
      singlepost: {},
      loadPostReady: false,
      lastestResult: 6,
      destinationpoints: []
    }
  },

  computed: {
    content() {
      return { title: this.title, labels: this.labels, search: this.search }
    },
    filters() {
      let filters = {}
      // this.post = this.slug;
      if (this.slug) filters.post = this.slug;
      if (this.author) filters.author = this.author
      if (this.category) filters.category = this.category
      if (this.search) filters.search = this.search

      return filters
    }
  },

  watch: {
    '$route.name' (to, from) {
      if (to !== from) {
        this.navs++;
        this.lastestResult = 6;
      }
      if (this.search !== '') {
        this.clearFeed();
      }
    },
    category (to, from) {
      if (to !== from) {
        this.clearFeed();
        this.lastestResult = 6;
        this.loadFeed(null, 6);
      }
    },
    search (to, from) {
      if (to !== from) {
        this.clearFeed();
        this.lastestResult = 6;
        // this.loadFeed(null, 6);
      }
    }
  },
  mounted() {
    if (this.$route.name === 'index' || this.$route.name === 'feed') {
      this.clearFeed();
    }
    this.$getResource('blog')
      .then(x => {
      })
    this.loadFeed(null, 6);
    // axios.get(`https://randomuser.me/api/?results=6`)
    //   .then(response => {
    //     this.feed = this.feed.concat(response.data.results);
    //   });
    this.getDestinationpoints();
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Blog.vue